export { GoogleTagManagerService } from './GoogleTagManager'
import { GoogleTagManagerService } from './GoogleTagManager'

export const GoogleTagManager = new GoogleTagManagerService()
